module.exports = __webpack_public_path__ + "static/media/gm-logo.dafd71d4.png";